exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".finity-upgrade-status{flex-direction:row;display:flex;align-items:center;gap:4px;border-radius:4px;background:#f8e4e5;width:max-content;height:28px;padding:6px 8px}.finity-upgrade-status .imp-text{font-size:12px;font-weight:400;color:#132056}.finity-upgrade-status .icon{height:16px;width:16px}.finity-upgrade-header{display:flex;flex-direction:row;align-items:center}.finity-upgrade-header .fuc-status{width:100%;margin-right:48px;flex-direction:column;display:flex;align-items:center}", ""]);

// exports
